@if (application) {
  <div class="card tpo-report-card">
    <div class="card-header">
      <h4 class="card-title"> <i class="fas fa-file-medical-alt"></i> Loan Details </h4>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-2 col-sm-6 col-xs-12">
          <h5 class="mt-0 mb-1">{{loanType ? loanType : '---'}}</h5>
          <span class="text-secondary">Loan Type</span>
        </div>
        <div class="form-group col-md-2 col-sm-6 col-xs-12">
          <h5 class="mt-0 mb-1">{{loanPurpose ? loanPurpose : '---'}}</h5>
          <span class="text-secondary">Loan Purpose</span>
        </div>
        @if (isPurchase) {
          <div class="form-group col-md-2 col-sm-6 col-xs-12">
            <h5 class="mt-0 mb-1">{{application.purchasePrice ? (application.purchasePrice | currency) : '---'}}</h5>
            <span class="text-secondary">Purchase Price</span>
          </div>
        }
        @if (!isPurchase) {
          <div class="form-group col-md-2 col-sm-6 col-xs-12">
            <h5 class="mt-0 mb-1">{{refinancePurpose ? refinancePurpose : '---'}}</h5>
            <span class="text-secondary">Refinance Purpose</span>
          </div>
        }
        <div class="form-group col-md-2 col-sm-6 col-xs-12">
          <h5 class="mt-0 mb-1">{{appraisedValue ? (appraisedValue | currency) : '---'}}</h5>
          <span class="text-secondary">Appraised Value</span>
        </div>
        <div class="form-group col-md-2 col-sm-6 col-xs-12">
          <h5 class="mt-0 mb-1">{{application.loanAmount ? (application.loanAmount | currency) : '---'}}</h5>
          <span class="text-secondary">Loan Amount</span>
        </div>
        <div class="form-group col-md-2 col-sm-6 col-xs-12">
          <h5 class="mt-0 mb-1">{{application.productPricing.price ? application.productPricing.price : '---'}}</h5>
          <span class="text-secondary">Price</span>
        </div>
      </div>
      <div class="row">
        @if (!isPurchase) {
          <div class="form-group col-md-6 col-sm-6 col-xs-12"></div>
        }
        @if (isPurchase) {
          <div class="form-group col-md-4 col-sm-6 col-xs-12"></div>
        }
        @if (isPurchase) {
          <div class="form-group col-md-2 col-sm-6 col-xs-12">
            <h5 class="mt-0 mb-1">{{downPayment ? (downPayment | currency) : '---'}}</h5>
            <span class="text-secondary">Down Payment</span>
          </div>
        }
      </div>
      <div class="row">
        <div class="form-group col-md-2 col-sm-6 col-xs-12">
          <h5 class="mt-0 mb-1">{{mortgage.reverseExtension.maxClaimAmount ? (mortgage.reverseExtension.maxClaimAmount | currency) : '---'}}</h5>
          <span class="text-secondary">Max Claim Amount</span>
        </div>
        <div class="form-group col-md-2 col-sm-6 col-xs-12">
          <h5 class="mt-0 mb-1">{{mortgage.reverseExtension.principalLimit ? (mortgage.reverseExtension.principalLimit | currency) : '---'}}</h5>
          <span class="text-secondary">Principal Limit</span>
        </div>
        <div class="form-group col-md-2 col-sm-6 col-xs-12">
          <h5 class="mt-0 mb-1">{{mortgage.reverseExtension.principalLimitFactor ? mortgage.reverseExtension.principalLimitFactor : '---'}}</h5>
          <span class="text-secondary">Principal Limit Factor</span>
        </div>
        <div class="form-group col-md-2 col-sm-6 col-xs-12">
          <h5 class="mt-0 mb-1">{{mortgage.reverseExtension.upb ? (mortgage.reverseExtension.upb | currency) : '---'}}</h5>
          <span class="text-secondary">UPB</span>
        </div>
        <div class="form-group col-md-2 col-sm-6 col-xs-12">
          <h5 class="mt-0 mb-1">{{mortgage.reverseExtension.plu ? mortgage.reverseExtension.plu : '---'}}</h5>
          <span class="text-secondary">PLU</span>
        </div>
        <div class="form-group col-md-2 col-sm-6 col-xs-12">
          <h5 class="mt-0 mb-1">{{mortgage.reverseExtension.fixedRate != null && mortgage.reverseExtension.fixedRate !== undefined ? (mortgage.reverseExtension.fixedRate / 100 | percent:'1.3-3') : '---'}}</h5>
          <span class="text-secondary">Rate</span>
        </div>
      </div>
      <div class="row">
        @if (isPRMG && application?.channel === 'NonDelegatedCorrespondent') {
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <h5 class="mt-0 mb-1">{{application.nonDelOptions ? getNonDelOptionName(application.nonDelOptions) : '---'}}</h5>
            <span class="text-secondary">Fulfillment Disclosure</span>
          </div>
        }
      </div>
    </div>
  </div>
}
